import { IAccessControl } from 'es/app/business-logic/domain-models/AccessControl';
import { IAccessGroup } from 'es/app/business-logic/domain-models/AccessGroup';
import EntityStore from 'es/app/store/EntityStore';
import { computed, makeObservable, observable } from 'mobx';

export default class AccessGroupsStore extends EntityStore<IAccessGroup> {
    constructor() {
        super();
        makeObservable(this, {
            accessGroups: computed,
            accessControls: observable
        });
    }

    public get accessGroups() { return this.entities; }

    public accessControls: IAccessControl[] = [];
}